import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux/es/exports";
import {useNavigate} from "react-router-dom";
import swal from "sweetalert";
import AddButton from "../../components/AddButton";
import Pagination from "../../components/Pagination";
import Select from "../../components/Select";
import {
    deleteTextureById,
    fetchDataTexture,
} from "../../services/textureService";
import {withTranslation} from "react-i18next";
import EditButton from "../../components/EditButton";
import DeleteButton from "../../components/DeleteButton";
import Loading from "../../components/loading";
import {toast} from "react-toastify";
import TempDataTable from "../../components/TemDataTable";
import SearchInput from "../../components/search/SearchInput";

const headerTable = [{
    name: "id", sort: false
}, {
    name: "laminate", sort: false
}, {
    name: "name", sort: true
}, {
    name: "color", sort: false
}, <span className="sr-only">Edit</span>,];


const bodyTable = ["id", "imageId", "name", "color", "actions"];

const TextureGroup = ({t}) => {
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [itemOffset, setItemOffset] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState({
        data: [],
        recordsTotal: 0,
        pageCount: 1,
    });
    const [forcePage, setForcePage] = useState(0);
    const {token} = useSelector((state) => state.user);
    const [sortColumn, setSortColumn] = useState("id");
    const [sortDir, setSortDir] = useState("DESC");
    const [clear, setClear] = useState(false);
    const navigate = useNavigate();

    const onDeleteItem = async (id) => {
        const responseReceived = await swal({
            title: t(`action.delete_item.title`),
            text: t(`action.delete_item.text`),
            icon: "warning",
            buttons: {
                cancel: true,
                confirm: true,
            },
        });
        if (responseReceived) {
            setIsLoading(true);
            const response = await deleteTextureById(
                `${process.env.REACT_APP_HOST_BASE_URL}/v1/texture/${id}`,
                token
            );
            if (response.success) {
                setIsLoading(false);
                fetchData();
                toast.success(t('action.delete_success'), {
                    position: "bottom-right",
                    autoClose: 3000,
                    closeOnClick: true,
                    className: "add-success"
                });
            } else {
                setIsLoading(false);
                if (response.status === 420) {
                    toast.warn(response.body.error, {
                        position: "bottom-right",
                        autoClose: 10000,
                        closeOnClick: true,
                        className: "product-background",
                        pauseOnHover: true,
                    });
                } else {
                    navigate("/error", {
                        state: {
                            status: response.status,
                            message: response.body ? response.body.error : "Error",
                        },
                    });
                }
            }
        } else {
            return;
        }
    };
    const fetchData = async () => {
        const response = await fetchDataTexture(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/texture/table`,
            token,
            {
                draw: 1,
                start: itemOffset,
                length: itemsPerPage,
                recordsTotal: 0,
                columns: [],
                order: [{column: sortColumn, dir: sortDir}],
                search: {value: "", regex: true},
                filter: {},
            }
        );
        if (response.success) {
            setIsLoading(false);
            setClear(false);
            let reviewData = response.data.data.map((item, index) => {
                return {
                    id: index + 1,
                    name: item.name,
                    color: (
                        <div
                            style={{backgroundColor: `${item.color}`}}
                            className={` w-full h-6 rounded-lg `}
                        ></div>
                    ),
                    imageId: item.imageId ? (
                        <img
                            className="object-cover w-6 h-6 rounded-full"
                            src={`${process.env.REACT_APP_HOST_BASE_URL}/v1/file/texture/${item.imageId}`}
                            alt={"img"}
                        />
                    ) : (
                        <p className=" text-[16px] font-bold ">{t(`no_laminate`)}</p>
                    ),
                    actions: (
                        <>
                            <EditButton onclick={() => navigate(`/textures/update/${item.id}`)}/>
                            <DeleteButton onclick={() => onDeleteItem(item.id)}/>
                        </>
                    ),
                };
            });
            setData({
                data: reviewData,
                recordsTotal: response.data.recordsFiltered,
                pageCount: Math.ceil(
                    response.data.recordsFiltered / parseInt(itemsPerPage)
                ),
            });
        } else {
            setIsLoading(false);
            navigate("/error", {
                state: {
                    status: response.status,
                    message: response.message ? response.message : null,
                },
            });
        }
    };

    useEffect(() => {
        if (clear) {
            fetchData();
        }
    }, [clear]);

    useEffect(() => {
        fetchData();
    }, [itemOffset, itemsPerPage]);

    const handlePageClick = (event) => {
        setForcePage(event.selected);
        const newOffset =
            (event.selected * parseInt(itemsPerPage)) % data.recordsTotal;
        setItemOffset(newOffset);
    };

    const sortFunction = (value) => {
        setSortColumn(value.field ? value.field : "id");
        setSortDir(value.sort === true ? 'ASC' : 'DESC');
        setClear(true);
    }

    return (
        <>
            {isLoading && <Loading/>}
            <div className="px-4 py-4 sm:px-6 lg:px-8">
                <div className='grid grid-cols-6 mt-4 gap-x-5'>
                    <div className="col-span-4 sm:col-span-2">
                        <div className="mb-2 sm:flex sm:items-center ">
                            <div className="sm:flex-auto">
                                <h1 className="text-xl font-semibold text-gray-900">
                                    {t(`supplier`)}
                                </h1>
                            </div>
                            {/*<AddButton title={t("add_supplier")} url={"add"}/>*/}
                        </div>
                        <div>
                            <Select
                                setItemsPerPage={setItemsPerPage}
                                itemsPerPage={itemsPerPage}
                            />
                            {/*<SearchInput/>*/}
                            <TempDataTable
                                data={data.data}
                                headerTable={headerTable}
                                bodyContent={bodyTable}
                                sortFunction={sortFunction}
                            />
                            <Pagination
                                handlePageClick={handlePageClick}
                                pageCount={data.pageCount}
                                forcePage={forcePage}
                            />
                        </div>
                    </div>
                    <div className="col-span-8 sm:col-span-4">
                        <div className="mb-2 sm:flex sm:items-center">
                            <div className="sm:flex-auto">
                                <h1 className="text-xl font-semibold text-gray-900">
                                    {t(`textures`)}
                                </h1>
                            </div>
                            <AddButton title={t(`add_textures`)} url={"add"}/>
                        </div>

                        <div>
                            <Select
                                setItemsPerPage={setItemsPerPage}
                                itemsPerPage={itemsPerPage}
                            />
                            <TempDataTable
                                data={data.data}
                                headerTable={headerTable}
                                bodyContent={bodyTable}
                                sortFunction={sortFunction}
                            />
                            <Pagination
                                handlePageClick={handlePageClick}
                                pageCount={data.pageCount}
                                forcePage={forcePage}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default withTranslation()(TextureGroup);
